import { create } from 'zustand';
import type { MapObject, Zone } from '@etown/shared';
import type { SitzAktion } from '../game/sitzen';

interface InteractionState {
  /** Interagierbares Objekt in Reichweite (fuer den "E druecken"-Hinweis). */
  nearbyObject: MapObject | null;
  /** Was dieselbe Taste am Stuhl bewirkt; null = kein Stuhl im Spiel. */
  sitzAktion: SitzAktion | null;
  /** Aktuell geoeffnetes Objekt (Modal). */
  openObject: MapObject | null;
  /** Zone, in der der eigene Avatar steht (HUD-Anzeige). */
  currentZone: Zone | null;
  /** Anzahl Personen pro Zone (Raum-Konferenz-Banner, Raumschilder). */
  zoneOccupants: Record<string, string[]>;
  setNearby: (obj: MapObject | null) => void;
  setSitzAktion: (aktion: SitzAktion | null) => void;
  openInteraction: (obj: MapObject) => void;
  closeInteraction: () => void;
  setZone: (zone: Zone | null) => void;
  setZoneOccupants: (occupants: Record<string, string[]>) => void;
}

export const useInteractionStore = create<InteractionState>((set) => ({
  nearbyObject: null,
  sitzAktion: null,
  openObject: null,
  currentZone: null,
  zoneOccupants: {},
  setNearby: (obj) =>
    set((state) => (state.nearbyObject?.id === obj?.id ? state : { nearbyObject: obj })),
  setSitzAktion: (aktion) => set((state) => (state.sitzAktion === aktion ? state : { sitzAktion: aktion })),
  openInteraction: (obj) => set({ openObject: obj }),
  closeInteraction: () => set({ openObject: null }),
  setZone: (zone) =>
    set((state) => (state.currentZone?.id === zone?.id ? state : { currentZone: zone })),
  setZoneOccupants: (occupants) => set({ zoneOccupants: occupants }),
}));
